import request from '@/utils/request'

/**
 * 【耗材节超】列表
 * @param {object} parameter
 * @property beamCode 梁号
 * @property beamModelId 梁型id
 * @property bridgeId 桥段id
 * @property orgId 组织id
 */
 export function materielExceedDetailList (parameter) {
  return request({
    url: '/beam/MaterielExceedDetail/list',
    method: 'get',
    params: parameter
  })
}
/**
 * 【耗材节超】详细
 * @param {object} parameter
 * @property beamId 梁唯一标识
 */
 export function getMaterielExceedDetail (parameter) {
  return request({
    url: `/beam/MaterielExceedDetail/detail`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【耗材节超】更新
 * @param {object} parameter
 * @property beamId 梁唯一标识
 */
 export function updateMaterielExceedDetail (parameter) {
  return request({
    url: `/beam/MaterielExceedDetail/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【压浆】左侧树
 * @param {object} parameter
 */
 export function listShebeibianhao (parameter) {
  return request({
    url: `/beam/YjsyM/listShebeibianhao`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【压浆-监测中心】新增
 * @param {object} parameter
 */
export function saveYjInfo (parameter) {
  return request({
    url: `/beam/YjsyM/saveYjInfo`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【压浆】恢复
 * @param {object} parameter
 * @property lianghao 梁号
 */
 export function beamRecover (parameter) {
  return request({
    url: `/beam/YjsyM/recover/${parameter.lianghao}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【压浆】修改
 * @param {object} parameter
 */
 export function updateYjsyS (parameter) {
  return request({
    // url: `/beam/YjsyS/`,
    url: `/beam/YjsyM/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【压浆】查看详细信息
 * @param {object} parameter
 * @property shebeibianhao 设备编号
 * */
 export function getYjsyMByShebeibianhao (parameter) {
  return request({
    url: `/beam/YjsyM/getYjsyMByShebeibianhao/${parameter.shebeibianhao}`,
    method: 'get'
  })
}
/**
 * 【压浆】查看详细信息
 * @param {object} parameter
 * @property lianghao 梁号
 */
 export function getYjsyMByLianghao (parameter) {
  return request({
    url: `/beam/YjsyM/getYjsyMByLianghao/${encodeURIComponent(parameter.lianghao)}`,
    method: 'get'
  })
}
/**
 * 【监测中心】列表
 * @param {object} parameter
 * @property lianghao 梁号
 */
 export function listYjsyS (parameter) {
  return request({
    url: `/beam/YjsyS/listYjsyS`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【监测中心】删除压浆数据
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function deleteYjsyS (parameter) {
  return request({
    url: `/beam/YjsyM/${parameter.id}`,
    method: 'delete',
    data: parameter
  })
}
/**
 * 【监测中心】操作记录
 * @param {object} parameter
 * @property startTime 开始时间
 * @property endTime 结束时间
 * @property search 操作人
 * @property type 操作类型 1张拉 2压浆
 *  */
 export function OperationRecord (parameter) {
  return request({
    url: `/beam/OperationRecord/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉-监测中心】新增
 * @param {object} parameter
 */
 export function saveZlsyM (parameter) {
  return request({
    url: `/beam/ZlsyM/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【张拉-监测中心】列表
 * @param {object} parameter
 * @property lianghao 梁号
 */
 export function listZlsyS (parameter) {
  return request({
    url: `/beam/ZlsyS/listZlsyS`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉】左侧树
 * @param {object} parameter
 */
 export function listZlShebeibianhao (parameter) {
  return request({
    url: `/beam/ZlsyM/listShebeibianhao`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉】查看详细信息-主表
 * @param {object} parameter
 * @property shebeibianhao 设备编号
 * */
 export function getZlsyMByShebeibianhao (parameter) {
  return request({
    url: `/beam/ZlsyM/getZlsyMByShebeibianhao/${parameter.shebeibianhao}`,
    method: 'get'
  })
}
/**
 * 【张拉】查看详细信息-主表
 * @param {object} parameter
 * @property gsbh 孔号
 * @property lianghao 梁号
 * @property shebeibianhao 设备编号
 * */
 export function getZlsyMByZlsyMReq (parameter) {
  return request({
    url: `/beam/ZlsyM/getZlsyMByZlsyMReq`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉】查看详细信息-子表
 * @param {object} parameter
 * @property fguid 设备编号
 * */
 export function ZlsySList (parameter) {
  return request({
    url: `/beam/ZlsyS/${parameter.fguid}`,
    method: 'get'
  })
}
/**
 * 【张拉】修改
 * @param {object} parameter
 * */
 export function updateZlData (parameter) {
  return request({
    url: `/beam/ZlsyM/updateZlData/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【张拉】恢复
 * @param {object} parameter
 * @property lianghao 梁号
 * @property gsbh 孔号
 * */
 export function ZlsyMrecover (parameter) {
  return request({
    url: `/beam/ZlsyM/recover`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉-监测中心】删除
 * @param {object} parameter
 * @property id 唯一标识
 * */
 export function deleteZlsyS (parameter) {
  return request({
    url: `/beam/ZlsyS/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【张拉】查询张拉压浆自定义设置表详情
 * @param {object} parameter
 * */
export function getZlyjCustom (parameter) {
  return request({
    url: `/beam/ZlyjCustom/getZlyjCustom`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【张拉】修改张拉压浆自定义设置表
 * @param {object} parameter
 * */
export function putZlyjCustom (parameter) {
  return request({
    url: `/beam/ZlyjCustom/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【过磅单】列表
 * @param {object} parameter
 * */
export function matWeighingOrderList (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【过磅单】保存
 * @param {object} parameter
 * */
export function saveMatWeighingOrder (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【过磅单】修改
 * @param {object} parameter
 * */
export function putMatWeighingOrder (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【过磅单】查询
 * @param {object} parameter
 * */
export function getMatWeighingOrder (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【过磅单】删除
 * @param {object} parameter
 * */
export function deletegetMatWeighingOrder (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【过磅单】选择批次
 * @param {object} parameter
 * */
export function listBatchSupplyPlan (parameter) {
  return request({
    url: `/AY220052Z/MatBatchSupplyPlan/listBatchSupplyPlan`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【过磅单】物资
 * @param {object} parameter
 * */
export function getMaterialsListForWeigh (parameter) {
  return request({
    url: `/AY220052Z/MatWeighingOrder/getMaterialsList`,
    method: 'get',
    params: parameter
  })
}

// #region --------------------------构件管理------------------------------

/**
 * 查询构件列表
 * @param {object} parameter
 */
export function getListComponent (parameter) {
  return request({
    url: `/materials/Component/listComponent`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查看构件表详情
 * @param {object} parameter
 */
export function getComponentById (parameter) {
  return request({
    url: `/materials/Component/getComponentById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 查询构建表物资列表
 * @param {object} parameter
 */
export function getListComponentMaterial (parameter) {
  return request({
    url: `/materials/ComponentMaterial/listComponentMaterial`,
    method: 'get',
    params: parameter
  })
}

/**
 * 更新构件表
 * @param {object} parameter
 */
export function updateComponent (parameter) {
  return request({
    url: `/materials/Component/updateComponent`,
    method: 'put',
    data: parameter
  })
}

/**
 * 保存构件表
 * @param {object} parameter
 */
export function saveComponent (parameter) {
  return request({
    url: `/materials/Component/saveComponent`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改构件表
 * @param {object} parameter
 */
export function editComponent (parameter) {
  return request({
    url: `/materials/Component/editComponent`,
    method: 'post',
    data: parameter
  })
}

/**
 * 根据id删除构件表
 * @param {object} parameter
 */
export function deleteComponentById (parameter) {
  return request({
    url: `/materials/Component/deleteComponentById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 批量修改构件表
 * @param {object} parameter
 */
export function batchUpdateComponent (parameter) {
  return request({
    url: `/materials/Component/batchUpdateComponent`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询构件编辑记录表列表
 * @param {object} parameter
 */
export function getListComponentEditRecording (parameter) {
  return request({
    url: `/materials/ComponentEditRecording/listComponentEditRecording`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询构件分类表列表
 * @param {object} parameter
 */
export function getListComponentCategory (parameter) {
  return request({
    url: `/materials/ComponentCategory/listComponentCategory`,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据工区id查询构件分类表列表
 * @param {object} parameter
 */
export function listComponentCategoryTable (parameter) {
  return request({
    url: `/materials/ComponentCategory/listComponentCategoryTable`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询下级不包含同名构件类型的工区列表
 * @param {object} parameter
 */
export function listComponentCategoryNeName (parameter) {
  return request({
    url: `/materials/ComponentCategory/listComponentCategoryNeName`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存构件工区表
 * @param {object} parameter
 */
export function saveComponentCategoryWork (parameter) {
  return request({
    url: `/materials/ComponentCategory/saveComponentCategory`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改构件工区表
 * @param {object} parameter
 */
export function editComponentCategory (parameter) {
  return request({
    url: `/materials/ComponentCategory/editComponentCategory`,
    method: 'post',
    data: parameter
  })
}

/**
 * 根据id删除构件分类表
 * @param {object} parameter
 */
export function deleteComponentCategoryById (parameter) {
  return request({
    url: `/materials/ComponentCategory/deleteComponentCategoryById/${parameter.id}`,
    method: 'delete',
    params: parameter
  })
}

/**
 * 根据构件id查询构建问题列表
 * @param {object} parameter
 */
export function getListComponentProblemMgtComponentId (parameter) {
  return request({
    url: `/materials/ComponentProblemMgt/listComponentProblemMgtComponentId/${parameter.componentId}`,
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------BIM构建问题管理------------------------------

/**
 * 查询构建问题管理表列表
 * @param {object} parameter
 */
export function getListComponentProblemMgt (parameter) {
  return request({
    url: `materials/ComponentProblemMgt/listComponentProblemMgt`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询构建问题管理详情
 * @param {object} parameter
 */
export function getComponentProblemMgtById (parameter) {
  return request({
    url: `materials/ComponentProblemMgt/getComponentProblemMgtById/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存构建问题管理表
 * @param {object} parameter
 */
export function saveComponentProblemMgt (parameter) {
  return request({
    url: `materials/ComponentProblemMgt/saveComponentProblemMgt`,
    method: 'post',
    data: parameter
  })
}

/**
 * 构建问题管理信息修改
 * @param {object} parameter
 */
export function updateComponentProblemMgt (parameter) {
  return request({
    url: `materials/ComponentProblemMgt/updateComponentProblemMgt`,
    method: 'put',
    data: parameter
  })
}

/**
 * 根据id删除构建问题管理表
 * @param {object} parameter
 * */
export function deleteComponentProblemMgtById (parameter) {
  return request({
    url: `materials/ComponentProblemMgt/deleteComponentProblemMgtById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 根据id查看指派记录
 * @param {object} parameter
 * */
export function listComponentProblemAssignmentRecord (parameter) {
  return request({
    url: `/materials/ComponentProblemAssignmentRecord/listComponentProblemAssignmentRecord`,
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------BIM构件物料管理------------------------------

/**
 * 查询构件物料详情
 * @param {object} parameter
 */
export function getComponentMaterialById (parameter) {
  return request({
    url: `materials/ComponentMaterial/getComponentMaterialById/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 构件物料信息修改
 * @param {object} parameter
 */
export function updateComponentMaterial (parameter) {
  return request({
    url: `materials/ComponentMaterial/updateComponentMaterial`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询构件物资表列表 - 导出验收附件压缩包
 * @param parameter
 * @returns {*}
 */
export function listComponentMaterialAcceptanceEnclosure (parameter = {}) {
  return request({
    url: 'materials/ComponentMaterial/listComponentMaterialAcceptanceEnclosure',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询导出记录表列表
 * @param parameter
 * @returns {*}
 */
export function listExportRecords (parameter = {}) {
  return request({
    url: 'user/ExportRecords/listExportRecords',
    method: 'get',
    params: parameter
  })
}

/**
 * BIM构件物资管理使用情况
 * @param parameter
 * @returns {*}
 */
export function getBimMaterialUseInfo (parameter = {}) {
  return request({
    url: `materials/ComponentCategory/bimMaterialUseInfo/${parameter.msgId || parameter.id}`,
    method: 'get',
    params: parameter
  })
}
// #endregion

// #region --------------------------BIM构件人员管理------------------------------

/**
 * 构件人员信息修改
 * @param {object} parameter
 */
export function updateComponentUserInfo (parameter) {
  return request({
    url: `materials/ComponentUserInfo/saveOrUpdateComponentUserInfo`,
    method: 'put',
    data: parameter
  })
}

// #endregion

// #region --------------------------工区看板管理------------------------------

/**
 * 查询看板的工区列表
 * @param {object} parameter
 */
export function listWorkArea (parameter) {
  return request({
    url: `/materials/WorkArea/listWorkArea`,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存看板的工区
 * @param {object} parameter
 */
export function saveWorkArea (parameter) {
  return request({
    url: `/materials/WorkArea/saveWorkArea`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改看板的工区
 * @param {object} parameter
 */
export function updateWorkArea (parameter) {
  return request({
    url: `/materials/WorkArea/updateWorkArea`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询工区信息看板详情
 * @param {object} parameter
 */
export function getWorkAreaInformationBoard (parameter) {
  return request({
    url: `/materials/WorkAreaInformationBoard/getWorkAreaInformationBoard/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改工区信息看板详情
 * @param {object} parameter
 */
export function updateWorkAreaInformationBoard (parameter) {
  return request({
    url: `/materials/WorkAreaInformationBoard/updateWorkAreaInformationBoard`,
    method: 'put',
    data: parameter
  })
}

/**
 * 根据id删除构件分类表
 * @param {object} parameter
 */
export function deleteWorkAreaById (parameter) {
  return request({
    url: `/materials/WorkArea/deleteWorkAreaById/${parameter.id}`,
    method: 'delete',
    params: parameter
  })
}

// #endregion

// #region --------------------------BIM构件类型管理------------------------------

/**
 * 查询构件类型列表
 * @param parameter
 * @returns {*}
 */
export function listComponentType (parameter = {}) {
  return request({
    url: `materials/ComponentCategory/listComponentType`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询构件类型详情
 * @param parameter
 * @returns {*}
 */
export function getComponentCategoryById (parameter = {}) {
  return request({
    url: `materials/ComponentCategory/getComponentCategoryById/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 新增构件类型表
 * @param parameter
 * @returns {*}
 */
export function saveComponentCategory (parameter = {}) {
  return request({
    url: `materials/ComponentCategory/saveComponentCategoryType`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改构件类型表
 * @param parameter
 * @returns {*}
 */
export function updateComponentCategory (parameter = {}) {
  return request({
    url: `materials/ComponentCategory/updateComponentCategory`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询构件类型详情-校验工序类型是否上传图片，上传图片的工序名称不能删除
 * @param parameter
 * @returns {*}
 */
export function checkHasEnclosure (parameter = {}) {
  return request({
    url: `materials/ComponentCategoryProcess/checkHasEnclosure`,
    method: 'put',
    data: parameter
  })
}

/**
* 批量修改损耗系数
* @param parameter
* @returns {*}
*/
export function updateComponentCategoryLossCoefficient (parameter = {}) {
 return request({
   url: `materials/ComponentCategory/updateComponentCategoryLossCoefficient`,
   method: 'put',
   data: parameter
 })
}
// #endregion
